export var DIVIDER_LENGTHS = Object.freeze({
  auto: 'auto',
  fixed: 'fixed',
  fluid: 'fluid'
});